const inputStyles = {
    '&>div': {
        pt: '22px',
    },
};
const MINNUMBEROFDAYS = 14;
const MAXNUMBEROFDAYS = 365;

const MINREUSELIMIT = 0;
const MAXREUSELIMIT = 100;

const MINMINPASSWORDAGE = 0;
const MAXMINPASSWORDAGE = 10;

export {
    inputStyles,
    MINNUMBEROFDAYS,
    MAXNUMBEROFDAYS,
    MINREUSELIMIT,
    MAXREUSELIMIT,
    MINMINPASSWORDAGE,
    MAXMINPASSWORDAGE,
};
